import { createContext, useContext } from "react";

import type { TabPaywallAnalyticsApi } from "./useTabPaywallAnalytics";

const TabPaywallAnalyticsContext = createContext<TabPaywallAnalyticsApi | null>(null);

export function TabPaywallAnalyticsProvider({
  value,
  children,
}: {
  value: TabPaywallAnalyticsApi;
  children: React.ReactNode;
}) {
  return (
    <TabPaywallAnalyticsContext.Provider value={value}>
      {children}
    </TabPaywallAnalyticsContext.Provider>
  );
}

export function useTabPaywallAnalyticsContext() {
  const context = useContext(TabPaywallAnalyticsContext);
  if (!context) {
    throw new Error("useTabPaywallAnalyticsContext must be used within TabPaywallAnalyticsProvider");
  }
  return context;
}

export function useOptionalTabPaywallAnalytics() {
  return useContext(TabPaywallAnalyticsContext);
}
